/* GLAVA cover — converted from the GLAVA Homepage design (dc runtime) to plain JS. */
(function () {
  'use strict';
const EY0 = 0.50, EY1 = 0.50, EY2 = -0.515;
const LINE_RATIO = 0.724, OUTLINE_RATIO = 0.56;

const clamp01 = v => v < 0 ? 0 : v > 1 ? 1 : v;
const seg = (p, a, b) => clamp01((p - a) / (b - a));
const ease = t => 1 - Math.pow(1 - t, 3);
const lerp = (a, b, t) => a + (b - a) * t;

class GlvCover {
  constructor(props) {
    this.props = props;
    const r = () => ({ current: null });
    Object.assign(this, {
      seqRef: r(), stageRef: r(), heroBgWrapRef: r(), heroDarkenRef: r(), heroCopyRef: r(),
      headerRef: r(), emblemRef: r(), connectorRef: r(), connectorPathRef: r(),
      outlineRef: r(), outlineLeftRef: r(), outlineRightRef: r(), panelRef: r(),
      headingClipRef: r(), headingRef: r(), bodyRef: r(), iconRef: r(), railRef: r(),
      videoRef: r(), farmPosterRef: r(), farmGradeRef: r(), loaderRef: r(),
      storyRef: r(), s3Ref: r(), s4Ref: r(), ovalRef: r(), s3ConnRef: r(), s3SpineRef: r(),
      figureRef: r(), s3HeadRef: r(), s3BodyRef: r(), s3MarkRef: r(),
      s4EchoRef: r(), s4BeanRef: r(), s4CurveRef: r(), beansRef: r(), sackRef: r(),
      s4HeadRef: r(), s4BodyRef: r(), s4MarkRef: r(), figLightRef: r(), figDarkRef: r(),
      railWrapRef: r(), railLightRef: r(), railDarkRef: r(), bridgeRef: r(), bridgeSvgRef: r(),
      s05WrapRef: r(), s05StageRef: r(), roastRef: r(), cupRef: r(), s05SpineRef: r(),
      s05TopRef: r(), s05BotRef: r(), capsuleRef: r(), capOutlineRef: r(),
      copyARef: r(), copyBRef: r(), capMarkRef: r(),
      s06Ref: r(), gridRef: r(), emblemS6Ref: r()
    });
    this.reduced = false;
  }

  componentDidMount() {
    this.reduced = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    this.rafId = 0;
    this.dirty = true;
    this.applyReducedS06();
    this.measure();

    this.request = () => {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => { this.rafId = 0; this.tick(); });
    };
    this.onScroll = () => { this.dirty = true; this.request(); };
    this.onResize = () => {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        this.measure();
        this.dirty = true;
        if (this.isFrozen()) { this.frozenAt = null; this.pinFrozen(); }
        this.request();
      }, 150);
    };
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);

    // anchors are re-measured after fonts and media settle, never per frame
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(this.onResize);
    this.root.querySelectorAll('[data-media]').forEach(el => {
      const show = () => { el.style.opacity = '1'; };
      el.addEventListener('canplay', show);
      if (el.readyState >= 2) show();
    });
    const v = this.videoRef.current;
    if (v) { const pr = v.play(); if (pr && pr.catch) pr.catch(() => {}); }
    this.mediaTimer = setTimeout(this.onResize, 900);

    this.pinFrozen();
    this.tick();
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.releaseFreeze();
    if (this.rafId) cancelAnimationFrame(this.rafId);
    clearTimeout(this.mediaTimer);
    clearTimeout(this.resizeTimer);
  }

  componentDidUpdate() {
    this.frozenAt = null;
    this.releaseFreeze();
    this.pinFrozen();
    this.dirty = true;
    this.request();
  }

  isFrozen() { return this.props.goldenFrameFreeze === true; }

  // Debug fixture for Sections 05/06: renders one frame at a fixed progress and stops.
  get freezeAt() {
    const v = this.props.freezeProgress;
    return (typeof v === 'number' && v >= 0) ? v : null;
  }
  goldenProgress() { return this.props.goldenFrameMidpoint ?? 0.5073; }

  /* ---------- GOLDEN FRAME FREEZE (dev fixture, default off) ----------
     Overrides ONLY the Sections 03/04 scene progress so the reference midpoint can be
     compared. The page keeps normal scrolling and every other section stays live. */
  pinFrozen() { this.dirty = true; }
  releaseFreeze() { this.dirty = true; }

  // The only place the scene is written. Renders once per changed progress value.
  tick() {
    if (this.H == null) return;
    const target = clamp01((window.scrollY - (this.seqTop || 0)) / this.range);
    if (!this.dirty && this.lastP != null && Math.abs(target - this.lastP) < 0.0005) return;
    this.lastP = target;
    this.dirty = false;
    this.frame();
  }

  measure() {
    const stage = this.stageRef.current, seq = this.seqRef.current;
    if (!stage || !seq) return;
    this.seqTop = seq.getBoundingClientRect().top + window.scrollY;
    this.H = stage.offsetHeight || 1;
    this.range = Math.max(1, seq.offsetHeight - this.H);

    const emb = this.emblemRef.current;
    this.embH = emb ? emb.offsetHeight || 82 : 82;

    const lineH = Math.round(this.H * LINE_RATIO);
    const con = this.connectorRef.current;
    if (con) { con.style.height = lineH + 'px'; }
    this.lineH = lineH;

    const path = this.connectorPathRef.current;
    if (path) {
      this.pathLen = path.getTotalLength();
      path.style.strokeDasharray = this.pathLen + ' ' + this.pathLen;
    }

    // outline ring is derived from the panel's real box so the two never drift apart
    const panel = this.panelRef.current;
    const panelW = panel ? panel.offsetWidth : 260;
    const panelH = panel ? panel.offsetHeight : 340;
    const panelCentre = this.H * 0.494;
    const outH = Math.round(panelH * 1.06);
    const outW = Math.round(panelW * 1.09);
    const out = this.outlineRef.current;
    if (out) { out.style.height = outH + 'px'; out.style.width = outW + 'px'; }
    this.outlineTop = panelCentre - outH / 2;

    // Anchor A: the panel's measured bottom-centre, in stage percentage units
    const bridge = this.bridgeRef.current;
    if (bridge) {
      const stageW = stage.offsetWidth || 1;
      const svg = this.bridgeSvgRef.current;
      if (svg) svg.setAttribute('viewBox', '0 0 ' + stageW + ' ' + this.H);
      const cx = stageW / 2;
      const y0 = panelCentre + panelH / 2 - 2;
      const span = (this.H + 3) - y0;
      bridge.setAttribute('d', 'M' + cx.toFixed(2) + ' ' + y0.toFixed(2) +
        'C' + cx.toFixed(2) + ' ' + (y0 + span * 0.34).toFixed(2) +
        ' ' + (cx - stageW * 0.007).toFixed(2) + ' ' + (y0 + span * 0.72).toFixed(2) +
        ' ' + cx.toFixed(2) + ' ' + (this.H + 3).toFixed(2));
      bridge._len = bridge.getTotalLength();
      bridge.style.strokeDasharray = bridge._len + ' ' + bridge._len;
    }
    this.joinY = this.outlineTop + 10 * (outH / 520);

    for (const ref of [this.outlineLeftRef, this.outlineRightRef]) {
      const el = ref.current;
      if (!el) continue;
      const L = el.getTotalLength();
      el._len = L;
      el.style.strokeDasharray = L + ' ' + L;
    }

    // solve the emblem's exit position so the drawn line ends exactly on the ring's join point
    this.ey2 = (this.joinY - this.embH / 2 - lineH) / this.H;

    const s3 = this.s3Ref.current, s4 = this.s4Ref.current, story = this.storyRef.current;
    const docY = window.scrollY;
    if (s3) { const r = s3.getBoundingClientRect(); this.s3Top = r.top + docY; this.s3H = r.height; }
    if (s4) { const r = s4.getBoundingClientRect(); this.s4Top = r.top + docY; this.s4H = r.height; }
    if (story) { const r = story.getBoundingClientRect(); this.storyTop = r.top + docY; this.storyH = r.height; }

    this.measureStory();
    this.measureLater();
  }

  frame() {
    if (this.H == null) return;
    const vh = window.innerHeight || 1;
    const p = clamp01((window.scrollY - (this.seqTop || 0)) / this.range);
    const H = this.H;

    // hero copy: 0-12%
    const cp = seg(p, 0, 0.12);
    const copy = this.heroCopyRef.current;
    if (copy) {
      copy.style.opacity = String(1 - ease(cp));
      copy.style.transform = 'translate3d(0,' + (-24 * ease(cp)).toFixed(1) + 'px,0)';
    }

    // header: 8-25%
    const hp = seg(p, 0.08, 0.25);
    const header = this.headerRef.current;
    if (header) {
      header.style.opacity = String(1 - ease(hp));
      header.style.transform = 'translate3d(0,' + (-18 * ease(hp)).toFixed(1) + 'px,0)';
      header.style.pointerEvents = hp > 0.6 ? 'none' : 'auto';
    }

    // emblem travel: down to centre, then up and out
    const t1 = ease(seg(p, 0, 0.22));
    const t2 = ease(seg(p, 0.45, 0.85));
    const emblemCentre = lerp(lerp(EY0, EY1, t1), this.ey2 == null ? EY2 : this.ey2, t2) * H;
    const emb = this.emblemRef.current;
    if (emb) emb.style.transform = 'translate3d(-50%,' + (emblemCentre - this.embH / 2).toFixed(1) + 'px,0)';

    // connector: attached to emblem bottom at every frame, scrubbed draw 15-55%
    const con = this.connectorRef.current, path = this.connectorPathRef.current;
    const lineTop = emblemCentre + this.embH / 2 - 2;
    if (con) con.style.transform = 'translate3d(-50%,' + lineTop.toFixed(1) + 'px,0)';
    if (path && this.pathLen) {
      const dp = seg(p, 0.15, 0.55);
      path.style.strokeDashoffset = (this.pathLen * (1 - dp)).toFixed(2);
      path.style.opacity = String(Math.min(1, seg(p, 0.13, 0.2)));
    }

    // farm footage in behind
    const fp = ease(seg(p, 0.05, 0.45));
    const vOp = Math.max(0, Math.min(1, fp));
    for (const ref of [this.videoRef, this.farmPosterRef]) {
      const el = ref.current;
      if (el) { el.style.opacity = String(vOp); el.style.transform = 'translate3d(0,0,0) scale(' + (1.05 - 0.05 * fp).toFixed(4) + ')'; }
    }
    const grade = this.farmGradeRef.current;
    if (grade) grade.style.opacity = String(vOp);

    // hero texture darkens then clears
    const dark = this.heroDarkenRef.current;
    if (dark) dark.style.opacity = String(0.34 * ease(seg(p, 0.14, 0.42)));
    const bg = this.heroBgWrapRef.current;
    if (bg) bg.style.opacity = String(1 - ease(seg(p, 0.25, 0.6)));

    // organic panel: 30-60%
    const pp = ease(seg(p, 0.30, 0.60));
    const panel = this.panelRef.current;
    if (panel) {
      panel.style.opacity = String(0.8 * pp);
      panel.style.transform = 'translate3d(-50%,-50%,0) scale(' + lerp(0.92, 1, pp).toFixed(4) + ')';
    }

    // orange outline halves: 35-75%
    const out = this.outlineRef.current;
    if (out) out.style.transform = 'translate3d(-50%,' + this.outlineTop.toFixed(1) + 'px,0)';
    const op = seg(p, 0.35, 0.75);
    for (const ref of [this.outlineRightRef, this.outlineLeftRef]) {
      const el = ref.current;
      if (el && el._len) el.style.strokeDashoffset = (el._len * (1 - op)).toFixed(2);
    }

    // heading 55-85%, paragraph trails
    const gp = ease(seg(p, 0.55, 0.85));
    const heading = this.headingRef.current;
    if (heading) heading.style.transform = 'translate3d(0,' + (110 * (1 - gp)).toFixed(1) + '%,0)';
    const bp = ease(seg(p, 0.60, 0.88));
    const body = this.bodyRef.current;
    if (body) { body.style.opacity = String(bp); body.style.transform = 'translate3d(0,' + (12 * (1 - bp)).toFixed(1) + 'px,0)'; }

    // botanical icon 70-100%
    const ip = ease(seg(p, 0.70, 1));
    const icon = this.iconRef.current;
    if (icon) { icon.style.opacity = String(ip); icon.style.transform = 'translate3d(0,' + (12 * (1 - ip)).toFixed(1) + 'px,0)'; }

    // scene rail
    const rp = ease(seg(p, 0.55, 0.82));
    const rail = this.railRef.current;
    if (rail) rail.style.opacity = String(rp);

    const bridge = this.bridgeRef.current;
    if (bridge && bridge._len) bridge.style.strokeDashoffset = (bridge._len * (1 - seg(p, 0.58, 0.88))).toFixed(2);

    this.storyFrame(vh);
    this.laterFrame(vh);
  }


  // ---------- Sections 05 + 06 ----------
  // Both read the same rAF tick. Section 05 is one pinned viewport of scrub:
  // p5 = clamp((scrollY - top) / (wrapperHeight - stageHeight), 0, 1).
  laterFrame(vh) {
    const y = window.scrollY;

    if (this.s05Top != null) {
      const p5 = this.freezeAt != null ? this.freezeAt : clamp01((y - this.s05Top) / this.s05Range);

      // vertical reveal: the cup layer rises, the roast layer drifts up behind it
      const r = clamp01(0.09 + 0.95 * p5);
      const cup = this.cupRef.current;
      if (cup) cup.style.transform = 'translate3d(0,' + ((1 - r) * 100).toFixed(3) + '%,0)';
      const roast = this.roastRef.current;
      if (roast) roast.style.transform = 'translate3d(0,' + (-9 * p5).toFixed(2) + '%,0)';

      // capsule: transform only, centre x fixed
      const cp = ease(seg(p5, 0, 0.2));
      const cap = this.capsuleRef.current;
      if (cap) cap.style.transform = 'translate3d(0,' + (10 * (1 - cp)).toFixed(2) + '%,0)';

      // one continuous spine: top connector -> capsule outline -> bottom connector
      const top = this.s05TopRef.current;
      if (top && top._len) top.style.strokeDashoffset = (top._len * (1 - seg(p5, 0, 0.14))).toFixed(2);
      const out = this.capOutlineRef.current;
      if (out && out._len) out.style.strokeDashoffset = (out._len * (1 - seg(p5, 0.12, 0.86))).toFixed(2);
      const bot = this.s05BotRef.current;
      if (bot && bot._len) bot.style.strokeDashoffset = (bot._len * (1 - seg(p5, 0.80, 1))).toFixed(2);

      // copy swap inside the stable capsule, 0.38 -> 0.62
      const sw = ease(seg(p5, 0.38, 0.62));
      const a = this.copyARef.current, b = this.copyBRef.current;
      if (a) { a.style.opacity = String(1 - sw); a.style.transform = 'translate3d(0,' + (-14 * sw).toFixed(1) + 'px,0)'; }
      if (b) { b.style.opacity = String(sw); b.style.transform = 'translate3d(0,' + (14 * (1 - sw)).toFixed(1) + 'px,0)'; }
      const mk = this.capMarkRef.current;
      if (mk) mk.style.opacity = String(ease(seg(p5, 0.55, 0.8)) * 0.85);
    }

    // Category gateway: six permanent cards in one grid. Scroll only reveals them.
    // No index, pair or beat state exists here — a card's identity is fixed in markup.
    if (!this.reduced && this.gridCards) {
      for (let i = 0; i < this.gridCards.length; i++) {
        const el = this.gridCards[i];
        if (el._shown) continue; // latched: once revealed a card stays at opacity 1 forever
        const t = ease(clamp01((y + vh * 0.9 - this.cardTops[i]) / (vh * 0.42)));
        el.style.opacity = t.toFixed(4);
        el.style.transform = 'translate3d(0,' + (18 * (1 - t)).toFixed(1) + 'px,0)';
        if (t > 0.999) {
          el._shown = true;
          el.style.opacity = '1';
          el.style.transform = 'none';
          el.style.willChange = 'auto';
        }
      }
    }
  }

  // Reduced motion: all six cards present and fully visible immediately.
  applyReducedS06() {
    if (!this.reduced) return;
    const grid = this.gridRef.current;
    if (!grid) return;
    grid.querySelectorAll('[data-card]').forEach(el => {
      el._shown = true;
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.willChange = 'auto';
    });
  }

  measureLater() {
    const s05 = this.s05WrapRef.current, stage = this.s05StageRef.current;
    const docY = window.scrollY;
    if (s05 && stage) {
      this.s05Top = s05.getBoundingClientRect().top + docY;
      this.s05Range = Math.max(1, s05.offsetHeight - stage.offsetHeight);
    }
    const grid = this.gridRef.current;
    if (grid) {
      this.gridCards = Array.from(grid.querySelectorAll('[data-card]'));
      // small per-column offset gives a left-to-right stagger without any index state
      this.cardTops = this.gridCards.map((el, i) => el.getBoundingClientRect().top + docY - (i % 3) * 30);
    }
    for (const ref of [this.s05TopRef, this.s05BotRef, this.capOutlineRef]) {
      const el = ref.current;
      if (!el) continue;
      el._len = el.getTotalLength();
      el.style.strokeDasharray = el._len + ' ' + el._len;
    }
  }

  measureStory() {
    for (const ref of [this.s3ConnRef, this.s4CurveRef]) {
      const el = ref.current;
      if (!el) continue;
      el._len = el.getTotalLength();
      el.style.strokeDasharray = el._len + ' ' + el._len;
      el.style.strokeDashoffset = el._len;
    }
  }

  // Sections 03 + 04 run on one parent timeline: p3 and p4 are the same
  // normalized value measured against each scene's travel through the viewport.
  storyFrame(vh) {
    const s3 = this.s3Ref.current, s4 = this.s4Ref.current;
    if (!s3 || !s4) return;
    const y = window.scrollY;
    // derived from anchors measured at load / debounced resize — never re-read here
    const r3 = { top: this.s3Top - y, height: this.s3H };
    const r4 = { top: this.s4Top - y, height: this.s4H };
    const bridge = this.bridgeRef.current;

    // Dev fixture: substitute the reference midpoint for THIS scene only.
    // At the frozen frame Section 04's top sits at gTop, so Section 03's top is gTop - its height.
    const frozen = this.isFrozen();
    const gTop = vh * this.goldenProgress();
    const t3 = frozen ? gTop - r3.height : r3.top;
    const t4 = frozen ? gTop : r4.top;
    const p3 = clamp01((vh - t3) / (vh + r3.height));
    const p4 = clamp01((vh - t4) / vh);

    if (bridge && bridge._len && t3 < vh) bridge.style.strokeDashoffset = '0';

    // --- Section 03 ---
    const ov = ease(seg(p3, 0.06, 0.26));
    const oval = this.ovalRef.current;
    if (oval) {
      oval.style.opacity = String(Math.min(1, seg(p3, 0.04, 0.20)));
      oval.style.transform = 'translate3d(0,' + (vh * 0.1 * (1 - ov)).toFixed(1) + 'px,0) scale(' + lerp(0.92, 1, ov).toFixed(4) + ')';
    }

    const head3 = this.s3HeadRef.current;
    if (head3) head3.querySelectorAll('[data-line]').forEach((el, i) => {
      const t = ease(seg(p3, 0.14 + i * 0.035, 0.40 + i * 0.035));
      el.style.transform = 'translate3d(0,' + (110 * (1 - t)).toFixed(1) + '%,0)';
    });
    const b3 = this.s3BodyRef.current;
    if (b3) {
      const t = ease(seg(p3, 0.19, 0.45));
      b3.style.opacity = String(t);
      b3.style.transform = 'translate3d(0,' + (14 * (1 - t)).toFixed(1) + 'px,0)';
    }

    const conn = this.s3ConnRef.current;
    if (conn && conn._len) conn.style.strokeDashoffset = (conn._len * (1 - seg(p3, 0.12, 0.46))).toFixed(2);

    const fig = this.figureRef.current;
    if (fig) {
      fig.style.opacity = String(1 - ease(seg(p4, 0.62, 0.86)));
      fig.style.clipPath = 'inset(0 0 ' + (100 * (1 - seg(p3, 0.30, 0.58))).toFixed(2) + '% 0)';
      const fr = fig.getBoundingClientRect();
      const split = Math.max(0, Math.min(fr.height, t4 - fr.top));
      const fl = this.figLightRef.current, fd = this.figDarkRef.current;
      if (fl) fl.style.clipPath = 'inset(0 0 ' + (fr.height - split).toFixed(1) + 'px 0)';
      if (fd) fd.style.clipPath = 'inset(' + split.toFixed(1) + 'px 0 0 0)';
    }

    s3.querySelectorAll('[data-cherry]').forEach(el => {
      const dy = parseFloat(el.dataset.dy) || 20, rot = parseFloat(el.dataset.rot) || 0;
      const t = clamp01((p3 - 0.10) / 0.90);
      el.style.transform = 'translate3d(0,' + (-dy * t).toFixed(1) + 'px,0) rotate(' + (rot * t).toFixed(1) + 'deg)';
    });

    // --- Section 04 ---
    // the macro rises on one decelerating curve; the golden midpoint is a point on it
    const rise = 1 - Math.pow(1 - seg(p4, 0.20, 1), 5.2);
    const bean = this.s4BeanRef.current;
    if (bean) {
      bean.style.opacity = String(Math.min(1, seg(p4, 0.20, 0.30)));
      bean.style.transform = 'translate3d(0,' + (vh * 0.86 * (1 - rise)).toFixed(1) + 'px,0)';
    }
    const echo = this.s4EchoRef.current;
    if (echo) {
      echo.style.opacity = String(Math.min(1, seg(p4, 0.20, 0.32)));
      echo.style.transform = 'translate3d(0,' + (vh * 0.86 * (1 - rise)).toFixed(1) + 'px,0)';
    }

    const curve = this.s4CurveRef.current;
    if (curve && curve._len) curve.style.strokeDashoffset = (curve._len * (1 - seg(p4, 0.44, 0.83))).toFixed(2);

    const head4 = this.s4HeadRef.current;
    if (head4) head4.querySelectorAll('[data-line]').forEach((el, i) => {
      const t = ease(seg(p4, 0.28 + i * 0.03, 0.46 + i * 0.03));
      el.style.transform = 'translate3d(0,' + (110 * (1 - t)).toFixed(1) + '%,0)';
    });
    const b4 = this.s4BodyRef.current;
    if (b4) {
      const t = ease(seg(p4, 0.30, 0.48));
      b4.style.opacity = String(t);
      b4.style.transform = 'translate3d(0,' + (14 * (1 - t)).toFixed(1) + 'px,0)';
    }

    const beansWrap = this.beansRef.current;
    if (beansWrap) beansWrap.querySelectorAll('[data-bean]').forEach(el => {
      const dy = (parseFloat(el.dataset.dy) || 20) * 0.5, rot = (parseFloat(el.dataset.rot) || 0) * 0.55;
      const t = clamp01((p4 - 0.25) / 0.75);
      el.style.opacity = String(Math.min(1, seg(p4, 0.0, 0.22)));
      el.style.transform = 'translate3d(0,' + (-dy * t).toFixed(1) + 'px,0) rotate(' + (rot * t).toFixed(1) + 'deg)';
    });

    const sack = this.sackRef.current;
    if (sack) {
      const t = ease(seg(p4, 0.85, 1));
      sack.style.opacity = String(t);
      sack.style.transform = 'translate3d(' + (26 * (1 - t)).toFixed(1) + 'px,' + (18 * (1 - t)).toFixed(1) + 'px,0)';
    }

    // --- shared rail: one column, recoloured where the beige boundary crosses it ---
    const story = this.storyRef.current, wrap = this.railWrapRef.current;
    if (story && wrap) {
      const rs = { top: this.storyTop - y, bottom: this.storyTop + this.storyH - y };
      const vis = rs.top < vh * 0.6 && rs.bottom > vh * 0.4;
      wrap.style.opacity = vis ? '1' : '0';
      const boundary = Math.max(0, Math.min(vh, t4));
      const light = this.railLightRef.current, dark = this.railDarkRef.current;
      if (light) light.style.clipPath = 'inset(0 0 ' + Math.round(vh - boundary) + 'px 0)';
      if (dark) dark.style.clipPath = 'inset(' + Math.round(boundary) + 'px 0 0 0)';
    }
  }

  renderVals() {
    return {
      seqRef: this.seqRef, stageRef: this.stageRef, heroBgWrapRef: this.heroBgWrapRef,
      heroDarkenRef: this.heroDarkenRef, heroCopyRef: this.heroCopyRef, headerRef: this.headerRef,
      emblemRef: this.emblemRef, connectorRef: this.connectorRef, connectorPathRef: this.connectorPathRef,
      outlineRef: this.outlineRef, outlineLeftRef: this.outlineLeftRef, outlineRightRef: this.outlineRightRef,
      panelRef: this.panelRef, headingClipRef: this.headingClipRef, headingRef: this.headingRef,
      bodyRef: this.bodyRef, iconRef: this.iconRef, railRef: this.railRef,
      videoRef: this.videoRef, farmPosterRef: this.farmPosterRef, farmGradeRef: this.farmGradeRef,
      loaderRef: this.loaderRef,
      storyRef: this.storyRef, s3Ref: this.s3Ref, s4Ref: this.s4Ref, ovalRef: this.ovalRef,
      s3ConnRef: this.s3ConnRef, s3SpineRef: this.s3SpineRef, figureRef: this.figureRef,
      s3HeadRef: this.s3HeadRef, s3BodyRef: this.s3BodyRef, s3MarkRef: this.s3MarkRef,
      s4EchoRef: this.s4EchoRef, s4BeanRef: this.s4BeanRef, s4CurveRef: this.s4CurveRef,
      beansRef: this.beansRef, sackRef: this.sackRef, s4HeadRef: this.s4HeadRef,
      s4BodyRef: this.s4BodyRef, s4MarkRef: this.s4MarkRef,
      figLightRef: this.figLightRef, figDarkRef: this.figDarkRef,
      railWrapRef: this.railWrapRef, railLightRef: this.railLightRef, railDarkRef: this.railDarkRef, bridgeRef: this.bridgeRef, bridgeSvgRef: this.bridgeSvgRef,
      s05WrapRef: this.s05WrapRef, s05StageRef: this.s05StageRef, roastRef: this.roastRef, cupRef: this.cupRef,
      s05SpineRef: this.s05SpineRef, s05TopRef: this.s05TopRef, s05BotRef: this.s05BotRef,
      capsuleRef: this.capsuleRef, capOutlineRef: this.capOutlineRef,
      copyARef: this.copyARef, copyBRef: this.copyBRef, capMarkRef: this.capMarkRef,
      s06Ref: this.s06Ref, gridRef: this.gridRef, emblemS6Ref: this.emblemS6Ref,
      true: true
    };
  }
}

  const DEFAULTS = { freezeProgress: -1, goldenFrameFreeze: false, goldenFrameMidpoint: 0.5073 };
  let current = null;

  function mount() {
    const root = document.getElementById('glv-cover');
    if (!root || root._glv) return;
    const c = new GlvCover(DEFAULTS);
    c.root = root;
    root.querySelectorAll('[data-glv-ref]').forEach(function (el) {
      const k = el.getAttribute('data-glv-ref');
      if (c[k] && 'current' in c[k]) c[k].current = el;
    });
    root._glv = c;
    current = c;
    c.componentDidMount();
  }

  function unmount() {
    if (current) { current.componentWillUnmount(); current = null; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  window.addEventListener('load', function () { if (current) current.onResize(); });

  // theme editor re-renders the section in place
  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#glv-cover')) unmount();
  });
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#glv-cover')) mount();
  });
})();
